import { Component, OnInit, Input } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {

  @Input() cardInfo:any;
  @Input() token = true;
  @Input() post = false;
  @Input() index = -1;
  @Input() isAppreciation: boolean;

  @Input() download = false;
  href = '';

  /** Imagen por defecto cuando el documento no tiene imagen (evita src="null") */
  readonly defaultImageUrl = '/assets/images/doc.webp';

  constructor() { }

  ngOnInit() {

    if (this.cardInfo.institution) {
      this.cardInfo.title = this.cardInfo.institution;
      this.cardInfo.date = this.cardInfo.creationDate;
    }

    if ( ( this.cardInfo.reqAuth != undefined && this.cardInfo.reqAuth > 0) || this.cardInfo.institution) {
      this.cardInfo.class = true;
    }

    if (this.cardInfo.name) {
      this.cardInfo.title = this.cardInfo.name;
    }

    if (this.cardInfo.reqAuth !== undefined && this.cardInfo.reqAuth > 0) {
       this.cardInfo.title = this.cardInfo.name;
       this.download = true;
       this.cardInfo.date2 = this.cardInfo.publicationDate;
       // this.cardInfo.token = '/'+this.cardInfo.url;
    }

    if (this.post) {
      this.cardInfo.token = `/publicaciones/${this.cardInfo.token}`;
    }


    if (this.token && !this.download) {
      this.cardInfo.token = (this.cardInfo.token) ? this.cardInfo.token : '/noticias';
    }
  }

  get imageSrc(): string {
    return (this.cardInfo && this.cardInfo.image) ? this.cardInfo.image : this.defaultImageUrl;
  }

  onImageError(event: Event): void {
    const img = event.target as HTMLImageElement;
    if (img && this.defaultImageUrl) {
      img.src = this.defaultImageUrl;
    }
  }
}
